<template>
    <transition @enter="enter" @leave="leave" appear>
        <div class="Navigation">
            <!-- <div class="Navigation__background" :style="{ backgroundImage: 'url(static/field.png)' }"/> -->
            <div class="Navigation-block">  
                <div class="Navigation__btn" v-for="(btn, index) in arr_phone" :key="index" @click="onClick(btn)" :class="{ added: $route.meta.name == btn }">
                    {{ trans('Navigation.'+ btn) }}
                    <!-- <div class="Navigation__btn-line" :class="{ added: $route.meta.name == btn }" /> -->
                </div>
                <div ref="motion" @click="$root.langSwitch()" class="App-lang" :class="getTint()" v-html="lang == 'fr' ? 'EN' : 'FR'" />
              <!--   <div class="Try2" >
                    <Try context="training"/>
                </div>  -->
            </div>   
        </div>
    </transition>

</template>

<script>

import gsap from "gsap"
import Colors from '@/config/Colors'


export default {

    name: 'Navigation',
    data: ()=>({
        arr_phone: [ 'about', 'knowledge', 'rules', 'training', 'results' ],
    }),
    computed:{
        tint() { return this.$store.getters['commons/tint'] }
    },

    mounted() { 
        this.$nextTick(()=>{
            // const delay = this.$route.meta.name == 'welcome' ? 3.8 : 1.5
            // gsap.from(['.Navigation', this.$refs.motion], { 
            //     stagger: .2,
            //     duration: .35, 
            //     opacity: 0, 
            //     y: -100, 
            //     delay: delay, 
            //     ease: 'back.out' 
            // })
        })
    },
    methods: {
        onClick(link) {
            this.updateRoute(link)
     
        },
        updateRoute(link) {
            this.burgerClick()
            this.$router.push({ name: link +'.' + this.lang }).catch(() => {})
        },
        getTint() {
            return this.tint
        },
        burgerClick() {
            this.$parent.is_open = !this.$parent.is_open
        },

        enter(el, done) {
            gsap.timeline({ delay: .5 })
                .from([ '.Navigation__btn', '.App-lang' ], { y: -25, duration: .25, opacity: 0, stagger: .12, ease: 'cubic.out', onComplete: ()=> done() })

        },
        leave(el, done) {
            gsap.timeline({ delay: .25 })
                .to([ '.Navigation__btn', '.App-lang', '.Try2'], { y: -25, duration: .25, opacity: 0, stagger: .1, ease: 'cubic.out' })
                .to(el, { opacity: 0, duration: .25, ease: 'none', onComplete: ()=> done() })

        },

    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Navigation
    width 100%
    height 100vh
    background-color rgba(white, 1)
    position absolute
    top 0
    z-index 100


    &__background
        position absolute
        width calc(100% - (var(--mw)*2))
        height calc(100% - var(--mw))
        left var(--mw)
        bottom 15%
        background-position center
        background-repeat no-repeat
        background-size cover
        border-radius var(--mw)

    &-block 
        padding-top calc(var(--hd) + 12px)
        display flex
        flex-direction column
            
        align-items flex-end
        padding-right 8px

        & .App-lang 
            margin-right 16px
            margin-top 16px

        & .Header__btn
            padding-top 8px

     &__btn
        display flex
        align-items center
        padding 0 calc(var(--mw)/2) 
        cursor pointer
        position relative
        height 32px

        &.added
            font-weight 500

        &-line 
            position absolute
            height 1px
            background-color rgba(dark, 1)
            bottom 7px
            transition width .2s
            transition-timing-function ease-out 
            width 0

            &.added
                width calc(100% - var(--mw))

    & .Try2
        width 54%
        position absolute
        right 23%
        bottom 15%
 
</style>


